<div class="ch-timepicker-item">
  <div class="input-group date" chDatetimepicker [value]="value" (onChange)="change($event)">
    <input type="text" class="form-control" value="{{ value }}" />
    <span class="input-group-addon"> <span class="glyphicon glyphicon-time"></span> </span>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/datetime-picker/datetime-picker.component.html